"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstanceType = exports.InfrastructureProvider = void 0;
var InfrastructureProvider;
(function (InfrastructureProvider) {
    InfrastructureProvider["Aws"] = "Aws";
    InfrastructureProvider["GoogleCloud"] = "GoogleCloud";
    InfrastructureProvider["Azure"] = "Azure";
})(InfrastructureProvider || (exports.InfrastructureProvider = InfrastructureProvider = {}));
/**
 * Instance types define the bandwidth capabilities of VPN instances
 */
var InstanceType;
(function (InstanceType) {
    InstanceType["Ultra"] = "Ultra";
    InstanceType["Fast"] = "Fast";
    InstanceType["Eco"] = "Eco";
})(InstanceType || (exports.InstanceType = InstanceType = {}));
